'use client';
import { SwitchStyled } from './switch.styles';

const Switch = SwitchStyled;

export default Switch;
